import React, { act } from "react";
import { IonTabBar, IonTabButton } from "@ionic/react";
import { useNavigate, useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import bottomChatbot from "../assets/imgs/bottom_chatbotai.svg";
import bottomFeedLanding from "../assets/imgs/bottom_news.svg";
import bottomToolbox from "../assets/imgs/bottom_toolbox.svg";
import bottomChatbotActive from "../assets/imgs/bottom_chatbotai_active.svg";
import bottombottomFeedActive from "../assets/imgs/bottom_news_active.svg";
import bottomToolboxActive from "../assets/imgs/bottom_toolbox_active.svg";

import { hapticsImpactLight } from "../lib/utils";
import { useMixpanel } from "../Context/MixpanelContext/MixpanelProvider";

const BottomTabNavigation = () => {
  const tabs = [
    {
      path: "/chatbot-ai",
      icon: bottomChatbot,
      activIcon: bottomChatbotActive,
      title: "Chat",
    },
    {
      path: "/news",
      icon: bottomFeedLanding,
      activIcon: bottombottomFeedActive,
      title: "News",
    },
    {
      path: "/toolbox",
      icon: bottomToolbox,
      activIcon: bottomToolboxActive,
      title: "Tools",
    },
  ];

  const navigate = useNavigate();
  const location = useLocation(); // Get current route
  const Mixpanel = useMixpanel();
  const isWeb = Capacitor.getPlatform() === 'web';
  const handleTabClick = (path: string) => {
    if (location.pathname === path) {
      return;
    }

    if (path === "/chatbot-ai") {
      Mixpanel.trackEvent("select_chatbot_navbar", {
        name: "User clicked chatbot tab",
      });
    } else if (path === "/news") {
      Mixpanel.trackEvent("select_news_navbar", {
        name: "User clicked news tab",
      });
    } else if (path === "/toolbox") {
      Mixpanel.trackEvent("select_tools_navbar", {
        name: "User clicked toolbox tab",
      });
    }

    hapticsImpactLight();
    navigate(path);
  };

  return (
    <IonTabBar slot="bottom" className="bg-[#000513]">
      {tabs.map((tab, index) => (
        <IonTabButton
          className={`bg-[#000513] ${!isWeb ? 'mt-[10px]' : ''}`}
          key={index}
          tab={tab.path}
          onClick={() => handleTabClick(tab.path)} // Navigate to tab path
        >
          <img
            src={location.pathname === tab.path ? tab.activIcon : tab.icon}
            alt="icon"
            className="mb-1"
          />
          <span
            className={`text-[10px] font-bold ${
              location.pathname === tab.path 
                ? "text-white" 
                : "text-white/50"
            }`}
          >
            {tab.title}
          </span>
        </IonTabButton>
      ))}
    </IonTabBar>
  );
};

export default BottomTabNavigation;
